// Phase 30 — Fahrer notifications bell (in-app)
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { fahrerApi } from "./lib/api";

const POLL_MS = 60_000;

export default function FahrerNotifBell() {
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);

  async function loadCount() {
    try {
      const { data } = await fahrerApi.get("/fahrer/notifications/_summary");
      setUnread(data?.unread || 0);
    } catch { /* ignore */ }
  }
  async function loadItems() {
    try {
      const { data } = await fahrerApi.get("/fahrer/notifications");
      setItems(data || []);
    } catch { setItems([]); }
  }

  useEffect(() => {
    loadCount();
    const id = setInterval(loadCount, POLL_MS);
    function onClick(e) {
      if (!e.target.closest?.("[data-fahrer-notif-root]")) setOpen(false);
    }
    window.addEventListener("click", onClick);
    return () => { clearInterval(id); window.removeEventListener("click", onClick); };
  }, []);

  async function toggle() {
    if (!open) await loadItems();
    setOpen((v) => !v);
  }

  async function markRead(n) {
    try { await fahrerApi.post(`/fahrer/notifications/${n.id}/read`); }
    catch { /* ignore */ }
    loadCount(); loadItems();
  }

  async function markAll() {
    try { await fahrerApi.post(`/fahrer/notifications/read-all`); }
    catch { /* ignore */ }
    loadCount(); loadItems();
  }

  return (
    <div className="relative" data-fahrer-notif-root data-testid="fahrer-notif-bell-root">
      <button type="button" onClick={toggle}
              data-testid="fahrer-notif-bell-btn"
              className="relative p-2 rounded text-zinc-400 hover:text-amber-400 hover:bg-zinc-900">
        <Bell className="w-4 h-4"/>
        {unread > 0 && (
          <span data-testid="fahrer-notif-badge"
                className="absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center leading-none">
            {unread > 99 ? "99+" : unread}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute top-10 right-0 w-72 max-h-[60vh] overflow-y-auto bg-zinc-900 border border-zinc-800 rounded-lg shadow-2xl z-50"
             data-testid="fahrer-notif-menu">
          <div className="px-3 py-2 border-b border-zinc-800 flex items-center justify-between">
            <span className="text-[10px] uppercase tracking-wide text-zinc-400 font-semibold">Benachrichtigungen</span>
            {unread > 0 && (
              <button onClick={markAll} data-testid="fahrer-notif-read-all"
                      className="text-[10px] text-amber-400 hover:text-amber-300">Alle gelesen</button>
            )}
          </div>
          {items.length === 0 ? (
            <div className="px-3 py-4 text-center text-zinc-500 text-xs italic">Keine Nachrichten</div>
          ) : (
            <div className="divide-y divide-zinc-800/60">
              {items.map((n) => (
                <Link to={n.link || "/fahrer"}
                      key={n.id}
                      onClick={() => { markRead(n); setOpen(false); }}
                      data-testid={`fahrer-notif-${n.id}`}
                      className={`block px-3 py-2.5 hover:bg-zinc-800/60 ${n.read ? "" : "bg-amber-500/5"}`}>
                  <div className="flex items-center justify-between gap-2">
                    <span className={`text-xs font-semibold ${n.read ? "text-zinc-300" : "text-amber-300"}`}>{n.title}</span>
                    <span className="text-[9px] text-zinc-500 font-mono">{(n.created_at || "").slice(5, 16).replace("T", " ")}</span>
                  </div>
                  {n.body && <div className="text-[11px] text-zinc-400 mt-0.5 line-clamp-2">{n.body}</div>}
                </Link>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
